import "../assets/index-73ded07b.css";
import { S as c } from "../chunks/ScopeComponent-3ea00dcd.mjs";
import { g as r } from "../chunks/focusTrap-5d0f71d4.mjs";
import { t as o } from "../chunks/l10n-ef44019c.mjs";
import { G as u } from "../chunks/GenRandomId-cb9ccebe.mjs";
import { l as d } from "../chunks/l10n-c603e589.mjs";
import p from "./NcActions.mjs";
import h from "./NcButton.mjs";
import "../Directives/Tooltip.mjs";
import { n as l } from "../chunks/_plugin-vue2_normalizer-71e2aa87.mjs";
import { C as m } from "../chunks/ChevronRight-1a6a6cf2.mjs";
import { C as f } from "../chunks/Close-271f72e2.mjs";
import { createFocusTrap as _ } from "focus-trap";
import { useSwipe as y } from "@vueuse/core";
import { VTooltip as w } from "floating-vue";
/**
 * @copyright Copyright (c) 2019 John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @author John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
function v(s, e) {
  let t, a, n = e, i;
  this.start = function() {
    i = !0, a = /* @__PURE__ */ new Date(), t = setTimeout(s, n);
  }, this.pause = function() {
    i = !1, clearTimeout(t), n -= /* @__PURE__ */ new Date() - a;
  }, this.clear = function() {
    i = !1, clearTimeout(t), n = 0;
  }, this.getTimeLeft = function() {
    return i && (this.pause(), this.start()), n;
  }, this.getStateRunning = function() {
    return i;
  }, this.start();
}
const g = {
  name: "ChevronLeftIcon",
  emits: ["click"],
  props: {
    title: {
      type: String
    },
    fillColor: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: Number,
      default: 24
    }
  }
};
var C = function() {
  var e = this, t = e._self._c;
  return t("span", e._b({ staticClass: "material-design-icon chevron-left-icon", attrs: { "aria-hidden": !e.title, "aria-label": e.title, role: "img" }, on: { click: function(a) {
    return e.$emit("click", a);
  } } }, "span", e.$attrs, !1), [t("svg", { staticClass: "material-design-icon__svg", attrs: { fill: e.fillColor, width: e.size, height: e.size, viewBox: "0 0 24 24" } }, [t("path", { attrs: { d: "M15.41,16.58L10.83,12L15.41,7.41L14,6L8,12L14,18L15.41,16.58Z" } }, [e.title ? t("title", [e._v(e._s(e.title))]) : e._e()])])]);
}, b = [], k = /* @__PURE__ */ l(
  g,
  C,
  b,
  !1,
  null,
  null,
  null,
  null
);
const S = k.exports, T = {
  name: "PauseIcon",
  emits: ["click"],
  props: {
    title: {
      type: String
    },
    fillColor: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: Number,
      default: 24
    }
  }
};
var x = function() {
  var e = this, t = e._self._c;
  return t("span", e._b({ staticClass: "material-design-icon pause-icon", attrs: { "aria-hidden": !e.title, "aria-label": e.title, role: "img" }, on: { click: function(a) {
    return e.$emit("click", a);
  } } }, "span", e.$attrs, !1), [t("svg", { staticClass: "material-design-icon__svg", attrs: { fill: e.fillColor, width: e.size, height: e.size, viewBox: "0 0 24 24" } }, [t("path", { attrs: { d: "M14,19H18V5H14M6,19H10V5H6V19Z" } }, [e.title ? t("title", [e._v(e._s(e.title))]) : e._e()])])]);
}, N = [], $ = /* @__PURE__ */ l(
  T,
  x,
  N,
  !1,
  null,
  null,
  null,
  null
);
const B = $.exports, P = {
  name: "PlayIcon",
  emits: ["click"],
  props: {
    title: {
      type: String
    },
    fillColor: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: Number,
      default: 24
    }
  }
};
var z = function() {
  var e = this, t = e._self._c;
  return t("span", e._b({ staticClass: "material-design-icon play-icon", attrs: { "aria-hidden": !e.title, "aria-label": e.title, role: "img" }, on: { click: function(a) {
    return e.$emit("click", a);
  } } }, "span", e.$attrs, !1), [t("svg", { staticClass: "material-design-icon__svg", attrs: { fill: e.fillColor, width: e.size, height: e.size, viewBox: "0 0 24 24" } }, [t("path", { attrs: { d: "M8,5.14V19.14L19,12.14L8,5.14Z" } }, [e.title ? t("title", [e._v(e._s(e.title))]) : e._e()])])]);
}, L = [], M = /* @__PURE__ */ l(
  P,
  z,
  L,
  !1,
  null,
  null,
  null,
  null
);
const A = M.exports;
const F = {
  name: "NcModal",
  components: {
    NcActions: p,
    ChevronLeft: S,
    ChevronRight: m,
    Close: f,
    Pause: B,
    Play: A,
    NcButton: h
  },
  directives: {
    tooltip: w
  },
  mixins: [d],
  props: {
    /**
     * Name to be shown with the modal
     */
    name: {
      type: String,
      default: ""
    },
    /**
     * Declare if a previous slide is available
     */
    hasPrevious: {
      type: Boolean,
      default: !1
    },
    /**
     * Declare if a next slide is available
     */
    hasNext: {
      type: Boolean,
      default: !1
    },
    /**
     * Declare if hiding the modal should be animated
     */
    outTransition: {
      type: Boolean,
      default: !1
    },
    /**
     * Declare if the slideshow functionality should be enabled
     */
    enableSlideshow: {
      type: Boolean,
      default: !1
    },
    /**
     * Declare the slide interval
     */
    slideshowDelay: {
      type: Number,
      default: 5e3
    },
    /**
     * Allow to pause an ongoing slideshow
     */
    slideshowPaused: {
      type: Boolean,
      default: !1
    },
    /**
     * Enable swipe between slides
     */
    enableSwipe: {
      type: Boolean,
      default: !0
    },
    spreadNavigation: {
      type: Boolean,
      default: !1
    },
    /**
     * Defines the modal size.
     * Default is 'normal'.
     * Available are 'small', 'normal', 'large' and 'full'.
     * All sizes except 'small' change automatically to full-screen on mobile.
     */
    size: {
      type: String,
      default: "normal",
      validator: (s) => ["small", "normal", "large", "full"].includes(s)
    },
    /**
     * Declare if the modal can be closed
     */
    canClose: {
      type: Boolean,
      default: !0
    },
    /**
     * Close the modal if the user clicked outside of the modal
     * Only relevant if `canClose` is set to true.
     */
    closeOnClickOutside: {
      type: Boolean,
      default: !0
    },
    /** Makes the modal backdrop black if true  */
    dark: {
      type: Boolean,
      default: !1
    },
    /**
     * Selector for the modal container, pass `null` to prevent automatic container mounting
     */
    container: {
      type: [String, null],
      default: "body"
    },
    /**
     * Pass in false if you want the modal 'close' button to be displayed
     * outside the modal boundaries, in the top right corner of the window
     */
    closeButtonContained: {
      type: Boolean,
      default: !0
    },
    /**
     * Additional elements to add to the focus trap
     */
    additionalTrapElements: {
      type: Array,
      default: () => []
    },
    /**
     * Display x items inline
     *
     * @see Actions component usage
     */
    inlineActions: {
      type: Number,
      default: 0
    },
    show: {
      type: Boolean,
      default: void 0
    }
  },
  emits: [
    "previous",
    "next",
    "close",
    "update:show"
  ],
  data() {
    return {
      mc: null,
      playing: !1,
      slideshowTimeout: null,
      iconSize: 24,
      focusTrap: null,
      randId: u(),
      internalShow: !0
    };
  },
  computed: {
    showModal() {
      return this.show === void 0 ? this.internalShow : this.show;
    },
    modalTransitionName() {
      return `modal-${this.outTransition ? "out" : "in"}`;
    },
    playPauseName() {
      return this.playing ? o("Pause slideshow") : o("Start slideshow");
    },
    cssVariables() {
      return {
        "--slideshow-duration": this.slideshowDelay + "ms",
        "--icon-size": this.iconSize + "px"
      };
    },
    closeButtonAriaLabel() {
      return o("Close");
    },
    prevButtonAriaLabel() {
      return o("Previous");
    },
    nextButtonAriaLabel() {
      return o("Next");
    }
  },
  watch: {
    /**
     * Handle play/pause of an ongoing slideshow
     *
     * @param {boolean} paused is the player paused
     */
    slideshowPaused(s) {
      this.slideshowTimeout && (s ? this.slideshowTimeout.pause() : this.slideshowTimeout.start());
    },
    additionalTrapElements(s) {
      if (this.focusTrap) {
        const e = this.$refs.mask;
        this.focusTrap.updateContainerElements([e, ...s]);
      }
    }
  },
  beforeMount() {
    window.addEventListener("keydown", this.handleKeydown);
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.handleKeydown), this.mc.stop();
  },
  mounted() {
    this.useFocusTrap(), this.mc = y(this.$refs.mask, {
      onSwipeEnd: this.handleSwipe
    }), this.container && (this.container === "body" ? document.body.insertBefore(this.$el, document.body.lastChild) : document.querySelector(this.container).appendChild(this.$el));
  },
  destroyed() {
    this.clearFocusTrap(), this.$el.remove();
  },
  methods: {
    // Events emitters
    previous(s) {
      this.hasPrevious && (s && this.resetSlideshow(), this.$emit("previous", s));
    },
    next(s) {
      this.hasNext && (s && this.resetSlideshow(), this.$emit("next", s));
    },
    close(s) {
      this.canClose && (this.internalShow = !1, this.$emit("update:show", !1), setTimeout(() => {
        this.$emit("close", s);
      }, 300));
    },
    /**
     * Handle click on modal wrapper
     * If `closeOnClickOutside` is set the modal will be closed
     *
     * @param {MouseEvent} event The click event
     */
    handleClickModalWrapper(s) {
      this.closeOnClickOutside && this.close(s);
    },
    /**
     * @param {KeyboardEvent} event - keyboard event
     */
    handleKeydown(s) {
      if (s.key === "Escape") {
        const t = r();
        return t.length > 0 && t[t.length - 1] !== this.focusTrap ? void 0 : this.close(s);
      }
      const e = {
        ArrowLeft: this.previous,
        ArrowRight: this.next
      };
      if (e[s.key])
        return document.activeElement && !this.$el.contains(document.activeElement) ? void 0 : e[s.key](s);
    },
    /**
     * handle the swipe event
     *
     * @param {TouchEvent} e The touch event
     * @param {import('@vueuse/core').SwipeDirection} direction Swipe direction
     */
    handleSwipe(s, e) {
      this.enableSwipe && (e === "left" ? this.next(s) : e === "right" && this.previous(s));
    },
    /**
     * Toggle the slideshow state
     */
    togglePlayPause() {
      this.playing = !this.playing, this.playing ? this.handleSlideshow() : this.clearSlideshowTimeout();
    },
    /**
     * Reset the slideshow timer and keep going if it was on
     */
    resetSlideshow() {
      this.playing = !this.playing, this.clearSlideshowTimeout(), this.$nextTick(function() {
        this.togglePlayPause();
      });
    },
    /**
     * Handle the slideshow timer and next event
     */
    handleSlideshow() {
      this.playing = !0, this.hasNext ? this.slideshowTimeout = new v(() => {
        this.next(), this.handleSlideshow();
      }, this.slideshowDelay) : (this.playing = !1, this.clearSlideshowTimeout());
    },
    /**
     * Clear slideshowTimeout if ongoing
     */
    clearSlideshowTimeout() {
      this.slideshowTimeout && this.slideshowTimeout.clear();
    },
    /**
     * Add focus trap for accessibility.
     */
    async useFocusTrap() {
      if (!this.showModal || this.focusTrap)
        return;
      const s = this.$refs.mask;
      await this.$nextTick();
      const e = {
        allowOutsideClick: !0,
        fallbackFocus: s,
        trapStack: r(),
        // Esc can be used without stop in content or additionalTrapElements where it should not deacxtivate modal's focus trap.
        // Focus trap is deactivated on modal close anyway.
        escapeDeactivates: !1
      };
      this.focusTrap = _([s, ...this.additionalTrapElements], e), this.focusTrap.activate();
    },
    clearFocusTrap() {
      var s;
      this.focusTrap && ((s = this.focusTrap) == null || s.deactivate(), this.focusTrap = null);
    }
  }
};
var E = function() {
  var e = this, t = e._self._c;
  return t("transition", { attrs: { name: "fade", appear: "" }, on: { "after-enter": e.useFocusTrap, "before-leave": e.clearFocusTrap } }, [t("div", { directives: [{ name: "show", rawName: "v-show", value: e.showModal, expression: "showModal" }], ref: "mask", staticClass: "modal-mask", class: { "modal-mask--dark": e.dark }, style: e.cssVariables, attrs: { role: "dialog", "aria-modal": "true", "aria-labelledby": "modal-name-" + e.randId, "aria-describedby": "modal-description-" + e.randId, tabindex: "-1" } }, [t("transition", { attrs: { name: "fade-visibility", appear: "" } }, [t("div", { staticClass: "modal-header" }, [e.name.trim() !== "" ? t("h2", { staticClass: "modal-name", attrs: { id: "modal-name-" + e.randId } }, [e._v(" " + e._s(e.name) + " ")]) : e._e(), t("div", { staticClass: "icons-menu" }, [e.hasNext && e.enableSlideshow ? t("button", { directives: [{ name: "tooltip", rawName: "v-tooltip.auto", value: e.playPauseName, expression: "playPauseName", modifiers: { auto: !0 } }], staticClass: "play-pause-icons", class: { "play-pause-icons--paused": e.slideshowPaused }, attrs: { type: "button" }, on: { click: e.togglePlayPause } }, [e.playing ? t("Pause", { staticClass: "play-pause-icons__pause", attrs: { size: e.iconSize } }) : t("Play", { staticClass: "play-pause-icons__play", attrs: { size: e.iconSize } }), t("span", { staticClass: "hidden-visually" }, [e._v(" " + e._s(e.playPauseName) + " ")]), e.playing ? t("svg", { staticClass: "progress-ring", attrs: { height: "50", width: "50" } }, [t("circle", { staticClass: "progress-ring__circle", attrs: { stroke: "white", "stroke-width": "2", fill: "transparent", r: "15", cx: "25", cy: "25" } })]) : e._e()], 1) : e._e(), t("NcActions", { staticClass: "header-actions", attrs: { inline: e.inlineActions } }, [e._t("actions")], 2), e.canClose && !e.closeButtonContained ? t("NcButton", { staticClass: "header-close", attrs: { "aria-label": e.closeButtonAriaLabel, type: "tertiary" }, on: { click: e.close }, scopedSlots: e._u([{ key: "icon", fn: function() {
    return [t("Close", { attrs: { size: e.iconSize } })];
  }, proxy: !0 }], null, !1, 1841713362) }) : e._e()], 1)])]), t("transition", { attrs: { name: e.modalTransitionName, appear: "" } }, [t("div", { directives: [{ name: "show", rawName: "v-show", value: e.showModal, expression: "showModal" }], staticClass: "modal-wrapper", class: [
    `modal-wrapper--${e.size}`,
    { "modal-wrapper--spread-navigation": e.spreadNavigation }
  ], on: { mousedown: function(a) {
    return a.target !== a.currentTarget ? null : e.handleClickModalWrapper.apply(null, arguments);
  } } }, [t("transition", { attrs: { name: "fade-visibility", appear: "" } }, [t("NcButton", { directives: [{ name: "show", rawName: "v-show", value: e.hasPrevious, expression: "hasPrevious" }], staticClass: "prev", attrs: { type: "tertiary-no-background", "aria-label": e.prevButtonAriaLabel }, on: { click: e.previous }, scopedSlots: e._u([{ key: "icon", fn: function() {
    return [t("ChevronLeft", { attrs: { size: 40 } })];
  }, proxy: !0 }]) })], 1), t("div", { staticClass: "modal-container", attrs: { id: "modal-description-" + e.randId } }, [e.canClose && e.closeButtonContained ? t("NcButton", { staticClass: "modal-container__close", attrs: { type: "tertiary", "aria-label": e.closeButtonAriaLabel }, on: { click: e.close }, scopedSlots: e._u([{ key: "icon", fn: function() {
    return [t("Close", { attrs: { size: 20 } })];
  }, proxy: !0 }], null, !1, 2121748766) }) : e._e(), t("div", { staticClass: "modal-container__content" }, [e._t("default")], 2)], 1), t("transition", { attrs: { name: "fade-visibility", appear: "" } }, [t("NcButton", { directives: [{ name: "show", rawName: "v-show", value: e.hasNext, expression: "hasNext" }], staticClass: "next", attrs: { type: "tertiary-no-background", "aria-label": e.nextButtonAriaLabel }, on: { click: e.next }, scopedSlots: e._u([{ key: "icon", fn: function() {
    return [t("ChevronRight", { attrs: { size: 40 } })];
  }, proxy: !0 }]) })], 1)], 1)])], 1)]);
}, I = [], R = /* @__PURE__ */ l(
  F,
  E,
  I,
  !1,
  null,
  "910493a0",
  null,
  null
);
const D = R.exports;
/**
 * @copyright Copyright (c) 2019 John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @author John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
c(D);
export {
  D as default
};
